module.exports = __webpack_public_path__ + "img/Changelly.730ed530.png";